import * as yup from 'yup';
import { EMAIL_MAX_LENGTH, EMAIL_REGEX } from '~/lib/patterns';

// The patterns live in `patterns.ts` so a browser can check a field without
// downloading yup. These schemas are built from the same constants, so there is
// one definition of "valid" — a cap or pattern on one side only would show the
// user one error while the other side reported a different one.
//
// Note `isValidSync(undefined)` is true for `.matches()` schemas (yup skips
// absent values), so callers still need their own emptiness guard.
const email = yup.string().trim().max(EMAIL_MAX_LENGTH).matches(EMAIL_REGEX);

const age = yup.number().min(18);

export default {
  email,
  age,
};
